@if (isSaving) {
<div class="spinner-area">
    <mat-progress-spinner class="spinner" mode="indeterminate" diameter="100"></mat-progress-spinner>
</div>
}
<div class="dialog-card">
    <div class="dialog-title">
        Import Compliance Requirements
    </div>
    <div class="add-container">
        <form method="POST" enctype="multipart/form-data" #fileForm (dragover)="updateDragState($event, true)"
            (dragleave)="updateDragState($event, false)" (drop)="getDroppedFiles($event)">

            <div class="drop-area" [ngClass]="{'drop-area-hover': isDragging}">
                <input type="file" id="file-input" #fileInput (change)="addSelectedFiles()" multiple>
                <div class="drop-area-actions">
                    <div class="drag-and-drop">
                        <div>
                            <mat-icon class="drag-and-drop-icon">backup</mat-icon>
                        </div>
                        <div class="drag-and-drop-text">
                            Drag & Drop
                        </div>
                    </div>
                    <div class="dnd-or">
                        OR
                    </div>
                    <div class="dnd-browse">
                            <button mat-flat-button (click)="browse($event)" class="browse-button">
                                BROWSE
                            </button>
                    </div>
                </div>
            </div>
        </form>

        <div class="result-container">

            @if (result && result.message && !result.isValid) {
            <div class="banner error-banner">
                <mat-icon class="banner-icon">sentiment_very_dissatisfied</mat-icon>
                <span class="banner-text">&nbsp;{{result.message}}</span>
            </div>
            }
            @if (result && result.preExistingFound) {
            <div class="banner warning-banner">
                <mat-icon class="banner-icon">warning</mat-icon>
                <span class="banner-text">&nbsp;Pre-Existing Compliance Requirement Found</span>
            </div>
            }
            @if (result && result.message && result.isValid) {
            <div class="banner">
                <mat-icon class="banner-icon">sentiment_very_satisfied</mat-icon>
                <span class="banner-text">&nbsp;{{result.message}}</span>
            </div>
            }
            @if (result && result.imported) {
            <div class="banner">
                <mat-icon class="banner-icon">sentiment_very_satisfied</mat-icon>
                <span class="banner-text">&nbsp;Compliance Requirements Imported Successfully</span>
            </div>
            }

            @if (result && result.duplicateJobs && result.duplicateJobs.length) {
            <div class="jobids-list">
                <div class="banner warning-banner">
                    <mat-icon class="banner-icon">warning</mat-icon>
                    <span class="banner-text">&nbsp;Duplicate Job Ids:</span>
                </div>
                <ul aria-label="valid job Ids">
                    @for (id of result.duplicateJobs; track id) {
                    <li>{{id}}</li>
                    }
                </ul>
                <button mat-flat-button color="primary" (click)="copyDuplicateIds()">
                    <mat-icon>content_copy</mat-icon>&nbsp;COPY LIST
                </button>
            </div>
            }

            @if (result && result.validJobs && result.validJobs.length) {
            <div class="jobids-list">
                <div class="banner">
                    <mat-icon class="banner-icon">sentiment_very_satisfied</mat-icon>
                    <span class="banner-text">&nbsp;Valid Job Ids</span>
                </div>
                <ul aria-label="valid job Ids">
                    @for (id of result.validJobs; track id) {
                    <li>{{id}}</li>
                    }
                </ul>
                <button mat-flat-button color="primary" (click)="copyValidIds()">
                    <mat-icon>content_copy</mat-icon>&nbsp;COPY LIST
                </button>
            </div>
            }

            @if (result && result.invalidJobs && result.invalidJobs.length) {
            <div class="jobids-list">
                <div class="banner warning-banner">
                    <mat-icon class="banner-icon">warning</mat-icon>
                    <span class="banner-text">&nbsp;Invalid Job Ids Found in File</span>
                </div>
                <ul aria-label="invalid job Ids">
                    @for (id of result.invalidJobs; track id) {
                    <li>{{id}}</li>
                    }
                </ul>
                <button mat-flat-button color="primary" (click)="copyInvalidIds()">
                    <mat-icon>content_copy</mat-icon>&nbsp;COPY LIST
                </button>
            </div>
            }

            @if (result && result.missingJobs && result.missingJobs.length) {
            <div class="jobids-list">
                <div class="banner warning-banner">
                    <mat-icon class="banner-icon">warning</mat-icon>
                    <span class="banner-text">&nbsp;Missing Job Ids in File</span>
                </div>
                <ul aria-label="missing job Ids">
                    @for (id of result.missingJobs; track id) {
                    <li>{{id}}</li>
                    }
                </ul>
                <button mat-flat-button color="primary" (click)="copyMissingIds()">
                    <mat-icon>content_copy</mat-icon>&nbsp;COPY LIST
                </button>
            </div>
            }

        </div>

        <div class="row button-bar">
            <button mat-flat-button (click)="importRequirements()"
                [disabled]="!file || isSaving || (result && !result.isValid)"
                [class.disabled]="result && !result.isValid"
                class="app-grid-header-right-button app-grid-header-dark-button">
                IMPORT REQUIREMENTS
            </button>

            <button mat-flat-button (click)="cancel()" #cancelButton
                class="app-grid-header-left-button cancel-button">
                {{ result?.imported ? 'CLOSE' : 'CANCEL' }}
            </button>
        </div>
    </div>
</div>
